import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { L10nLocale, L10nTranslationService, L10N_LOCALE } from 'angular-l10n';
import { loadMessages, locale } from 'devextreme/localization';
import { AuthenticationService } from '../services/authentication.service';
import { HcProviderService } from '../services/hc-provider.service';
import messagesHu from 'devextreme/localization/messages/hu.json';
import { Doctor, HcProviderLink, HealthcareProvider, LoginUser, PatientDataViewModel } from '../services/webapiclient.service';
import CustomStore from 'devextreme/data/custom_store';
import notify from 'devextreme/ui/notify';
import { Role } from '../models/role';
import { PatientService } from '../module-patient/patient.service';

  /**
   * NEM HASZNÁLJUK!
   * Eü. szolgáltató és felhasználó több-több kapcsolat kezelésére lett létrehozva.
   * Később kiderült, hogy egy az egy kapcsolat kell, így nem használjuk
   */

@Component({
    selector: 'app-hc-provider-link',
    templateUrl: './hc-provider-link.component.html',
    styleUrls: ['./hc-provider-link.component.scss'],
    standalone: false
})
export class HcProviderLinkComponent implements OnInit {
  providersDataSource: any;
  selectedProviders: number[] = [];
  doctorSource: any;
  selectedDoctor: string;
  selectionMode: any;
  currentUser: LoginUser;
  error = '';
  hcProviderLinks: HcProviderLink[] = {} as HcProviderLink[] ;
  dropDownInstance: any;
  gridInstance: any;
  doctorUser: boolean;
  loading = false;

  patientDataViewModel: PatientDataViewModel = {} as PatientDataViewModel;

  constructor(
    private hcProviderService: HcProviderService,
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private route: ActivatedRoute,
    private translation: L10nTranslationService,
    private patientService: PatientService,
    private authenticationService: AuthenticationService
)
  {
    const huMessages = JSON.stringify(messagesHu['hu']);
    loadMessages({
     'hu': JSON.parse(huMessages)
    });

    this.selectedDoctor="8E3066C5-FE8F-4DC0-A0D6-55646777874F";

    this.providersDataSource = new CustomStore({
      key: "id",
      loadMode: "raw",
      cacheRawData: false,
      load: () => hcProviderService.getAll()
     });

   }

  buttonOptions: any = {
    text: this.translation.translate('Core.EditSave'),
    type: "success",
    useSubmitBehavior: true
  }

  ngOnInit(): void {
    this.translation.onChange().subscribe(
       x=>{ 
         locale(x.language);
       });
    
       this.authenticationService.currentUser.subscribe(x => {
         this.currentUser = x;
         this.doctorUser = this.currentUser.role==Role.Doctor;
         this.getLinks();
         this.getPatientData(this.currentUser.id);
        } );

    // get return url from route parameters or default to '/'
    //this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
   }

   getPatientData(id: string){
    this.loading = true;
    this.patientService.getPatient(id).then(
        result => {
            this.patientDataViewModel = <PatientDataViewModel> result;
            this.selectedDoctor=this.patientDataViewModel.doctorId;
            this.loading = false;
         }
    ).catch(err => {
        this.error = err;
        this.loading = false;
   });
}

    getLinks(){
    this.selectedProviders = [];
    this.hcProviderService.getLinks(this.currentUser.id).then(
      result => {
        this.hcProviderLinks = <HcProviderLink[]> result;
        this.hcProviderLinks.forEach( (link) => {
          this.selectedProviders.push(link.providerId);
          });
          this.dropDownInstance.repaint();
          if(!this.doctorUser && this.selectedProviders[0]){
            //Ha nem orvos, akkor betöltjük a szolgáltató orvosait
            this.loadDoctorSource(this.selectedProviders[0]);
          }
       }
      ).catch(err => {
          this.error = err;
    });  
   }

   loadDoctorSource(providerId){
    this.hcProviderService.getDoctorsByProvider(providerId).then(
      result => {
        this.doctorSource = <Doctor[]> result;
       }
      ).catch(err => {
          this.error = err;
    });  
   }

  onDoctorChanged(e){
    this.patientDataViewModel.PatientDataId = this.currentUser.id;
    this.patientDataViewModel.doctorId = e.value;

     //let result: any;
     this.patientService.saveDoctorAndProviderId(this.currentUser.id,JSON.stringify(this.patientDataViewModel)).then(
      result => {
        if(result == "OK"){
         }
        }
      ).catch(err => {
          this.error = err;
      });
  }    

   onFormSubmit = function(e) {
    this.error = ""; 
    this.loading = true;
    let hcLinkList: HcProviderLink[] = [];

    if(this.selectedProviders){
      //Van kiválasztott szoláltató, betöltjük a healthcareProvider
      this.selectedProviders.forEach( (currentValue) => {
        hcLinkList.push({ providerId: currentValue, userId: this.currentUser.id });
      });
    }

    this.hcProviderService.insertLink(this.currentUser.id, JSON.stringify(hcLinkList)).then(
      result => {
        if(result == "OK"){
          notify({
             message: "Sikeres mentés!",
             position: {
                 my: "center top",
                 at: "center top"
             }
         }, "success", 2000);
         this.getLinks();
          //this.router.navigate(['/login']);
        }else{
          this.error = result;
          this.loading = false;
         }
        }
      ).catch(err => {
          this.error = err;
          this.loading = false;
      });
        
      e.preventDefault();
   }

   initDropDown (e) {
    this.dropDownInstance = e.component;
   }
   initGrid (e) {
     const that = this;
    setTimeout(function() {  
      if(that.doctorUser){
        e.component.option('selection',{mode:'multiple',showCheckBoxesMode:'always'});  
      } else{
        e.component.option('selection',{mode:'single',showCheckBoxesMode:'always'});  
      }
    }, 100);  
  }
}
